module.exports = __webpack_public_path__ + "static/media/bombolulu_bedsitters6.284b83c3.webp";